import React, { useEffect, useState } from "react";
import { FaEdit, FaSave } from "react-icons/fa";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { Link } from "react-router-dom";
import api from "../../config/URL";
import { toast } from "react-toastify";

function CMSTermsAndConditionsPage() {
  const [content, setContent] = useState("");
   const [contentId, setContentId] = useState("");
   console.log("content ::",contentId);
  const [isEditing, setIsEditing] = useState(false);
  const [loadIndicator, setLoadIndicator] = useState(false);

  // Fetch terms and conditions on component mount
  useEffect(() => {
    const fetchTermsAndConditions = async () => {
      setLoadIndicator(true);
      try {
        const response = await api.get("/getAllTermsAndConditionSave");
        if (response.status === 200) {
          setContent(response.data[0]?.termsConditionContent || "");
          setContentId(response.data[0]?.id || "");
        }
      } catch (error) {
        toast.error(error.response?.data?.message || "Failed to fetch terms and conditions");
      } finally {
        setLoadIndicator(false);
      }
    };

    fetchTermsAndConditions();
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, []);

  const handleContentChange = (value) => {
    setContent(value);
  };

  const handleSave = async () => {
    setLoadIndicator(true);
    try {
      const response = await api.put(`/updateTermsAndConditionSave/${contentId}`, {
        termsConditionContent: content,
      });
      if (response.status === 201 || response.status === 200) {
        toast.success(response.data.message);
        setIsEditing(false);
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to save terms and conditions");
    } finally {
      setLoadIndicator(false);
    }
  };

  const handlePublish = async () => {
    setLoadIndicator(true);
    try {
      const response = await api.post(`/publishTermsAndCondition`, {
        termsConditionContent: content,
      });
      if (response.status === 201 || response.status === 200) {
        toast.success(response.data.message);
        setIsEditing(false);
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to publish terms and conditions");
    } finally {
      setLoadIndicator(false);
    }
  };

  const handleEdit = () => {
    setIsEditing(true);
  };

  const quillModules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      [{ font: [] }],
      [{ size: [] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [{ align: [] }],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link", "image", "video"],
      ["clean"],
    ],
  };

  return (
    <section style={{ backgroundColor: "#f9fafb" }}>
      <ol
        className="breadcrumb my-3 px-1"
        style={{ listStyle: "none", padding: 0, margin: 0 }}
      >
        <li>
          <Link to="/" className="custom-breadcrumb">
            Home
          </Link>
          <span className="breadcrumb-separator"> &gt; </span>
        </li>
        <li>
          Content Management
          <span className="breadcrumb-separator"> &gt; </span>
        </li>
        <li className="breadcrumb-item active" aria-current="page">
          Terms & Conditions
        </li>
      </ol>
      <div className="container cms-header shadow-sm py-2">
        <div className="row p-1">
          <div className="col-md-6 col-12">
            <h4 className="headColor">Terms & Conditions</h4>
          </div>
          <div className="col-md-6 col-12 d-flex justify-content-end">
            {loadIndicator ? (
              <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            ) : !isEditing ? (
              <>
                <button
                  className="btn btn-sm btn-outline me-2"
                  onClick={handleEdit}
                  disabled={loadIndicator}
                >
                  <FaEdit />
                </button>
                <button
                  className="btn btn-sm custom-outline-danger border ms-2"
                  onClick={handlePublish}
                  disabled={loadIndicator}
                >
                  Publish
                </button>
              </>
            ) : (
              <button
                className="btn btn-sm text-primary me-2"
                onClick={handleSave}
                disabled={loadIndicator}
              >
                {loadIndicator ? (
                  <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                ) : (
                  <FaSave />
                )}
              </button>
            )}
          </div>
        </div>
      </div>
      <div className="container py-5">
        <div className="row mb-5">
          <div className="col-12">
            {loadIndicator ? (
              <div className="text-center">
                <span className="spinner-border" role="status" aria-hidden="true"></span>
              </div>
            ) : isEditing ? (
              <ReactQuill
                theme="snow"
                value={content}
                onChange={handleContentChange}
                modules={quillModules}
                style={{ minHeight: "300px" }}
              />
            ) : (
              <div
                className="termsPara"
                dangerouslySetInnerHTML={{ __html: content }}
              />
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

export default CMSTermsAndConditionsPage;